import HomePage from '../pages/Home/HomePage'
import React from 'react'
import { Navigate } from 'react-router-dom'

export const HOME_PATH = '/home'

export const HOME_ROUTES = [
	{
		index: true,
		element: <Navigate to={HOME_PATH} replace />,
	},
	{
		path: HOME_PATH,
		element: <HomePage />,
	},
]
